import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class RuleModalStore extends BaseModalStore {
  /** 活动规则配置 */
  @observable ruleInfo = {};

  setRuleInfo = ruleInfo => {
    this.ruleInfo = ruleInfo;
  };

  /** 关闭活动规则弹窗 */
  onRuleModalClose = () => {
    this.onClickClose();
    if (this.closeCb) {
      this.closeCb();
    }
    this.onClose();
  };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
  }
}

export default RuleModalStore;
